import { inject, provideAppInitializer } from '@angular/core';

import { RoutesService } from '@abp/ng.core';
import { eFileManagementRouteNames } from '@volo/abp.ng.file-management/common';

import { applicationRoutes } from './abp.routes';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);

  routes.add(applicationRoutes);
  //remove File Management from Root of menu so that it can be added
  //to own custom routes within our own modules
  routes.remove([eFileManagementRouteNames.FileManagement]);
}
